import React, { createContext, useState, useCallback } from 'react';
import Modal from '../Modal/Modal';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
  });

  const showModal = useCallback(({ title, message, onConfirm, onCancel }) => {
    setModal({ isOpen: true, title, message, onConfirm, onCancel });
  }, []);

  const hideModal = useCallback(() => {
    setModal({ isOpen: false, title: '', message: '', onConfirm: null, onCancel: null });
  }, []);

  const handleConfirm = useCallback(async () => {
    if (modal.onConfirm) {
      const shouldKeepOpen = await modal.onConfirm();
      if (shouldKeepOpen !== false) {
        hideModal();
      }
    }
  }, [modal.onConfirm, hideModal]);

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <Modal
        isOpen={modal.isOpen}
        title={modal.title}
        message={modal.message}
        onConfirm={handleConfirm}
        onCancel={modal.onCancel || hideModal}
      />
    </ModalContext.Provider>
  );
};